import { notificationSettingsResponseSchema, updateNotificationSettingsBodySchema, } from '../contracts/notification-settings';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * Get personal notification settings for the current user.
 * Returns the user's configured minimum alert severity threshold.
 *
 * When feature flag is OFF, returns 'low' (show all notifications = current behavior).
 * When no setting exists, returns default 'high' for personal users.
 */
export async function getUserNotificationSettings(client) {
    const response = await client.get('/account/settings/notifications');
    return parseSchema(notificationSettingsResponseSchema, response);
}
/**
 * Update personal notification settings for the current user.
 * Creates or updates the user's minimum alert severity threshold.
 */
export async function updateUserNotificationSettings(client, body) {
    const validatedBody = parseSchema(updateNotificationSettingsBodySchema, body);
    const response = await client.put('/account/settings/notifications', validatedBody);
    return parseSchema(notificationSettingsResponseSchema, response);
}
/**
 * Get organization notification settings.
 * Returns the organization's configured minimum alert severity threshold.
 *
 * Authorization: Owner, Manager, or Member (all can view).
 *
 * When feature flag is OFF, returns 'low' (show all notifications = current behavior).
 * When no setting exists, returns default 'none' for organization context.
 */
export async function getOrgNotificationSettings(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/settings/notifications`);
    return parseSchema(notificationSettingsResponseSchema, response);
}
/**
 * Update organization notification settings.
 * Creates or updates the organization's minimum alert severity threshold.
 *
 * Authorization: Owner or Manager only (members cannot modify).
 */
export async function updateOrgNotificationSettings(client, organizationId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedBody = parseSchema(updateNotificationSettingsBodySchema, body);
    const response = await client.put(`/organizations/${validatedId}/settings/notifications`, validatedBody);
    return parseSchema(notificationSettingsResponseSchema, response);
}
//# sourceMappingURL=notification-settings.js.map